'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n\n  span {\n    display: block;\n    font-weight: 500;\n    margin-bottom: 10px;\n  }\n\n  input {\n    ', '\n\n    background-color: ', ';\n    border: 1px solid ', ';\n    box-shadow: ', ';\n    font-size: ', ';\n    height: ', ';\n    padding: 0 ', ';\n    width: 100%;\n\n    &:disabled {\n      background-color: ', ';\n      border: 1px solid ', ';\n      box-shadow: none;\n      cursor: default;\n    }\n\n    &::placeholder {\n      font-style: italic;\n    }\n  }\n\n  .react-autosuggest__suggestions-container {\n    display: none;\n  }\n\n  .react-autosuggest__suggestions-container--open {\n    background-color: ', ';\n    border: 1px solid ', ';\n    display: block;\n    font-weight: 300;\n    min-width: 100%;\n    position: absolute;\n    top: 100%;\n    z-index: 2;\n  }\n\n  .react-autosuggest__suggestion {\n    cursor: pointer;\n    padding: 10px 20px;\n  }\n\n  .react-autosuggest__suggestion--highlighted {\n    background-color: ', ';\n  }\n'], ['\n  position: relative;\n\n  span {\n    display: block;\n    font-weight: 500;\n    margin-bottom: 10px;\n  }\n\n  input {\n    ', '\n\n    background-color: ', ';\n    border: 1px solid ', ';\n    box-shadow: ', ';\n    font-size: ', ';\n    height: ', ';\n    padding: 0 ', ';\n    width: 100%;\n\n    &:disabled {\n      background-color: ', ';\n      border: 1px solid ', ';\n      box-shadow: none;\n      cursor: default;\n    }\n\n    &::placeholder {\n      font-style: italic;\n    }\n  }\n\n  .react-autosuggest__suggestions-container {\n    display: none;\n  }\n\n  .react-autosuggest__suggestions-container--open {\n    background-color: ', ';\n    border: 1px solid ', ';\n    display: block;\n    font-weight: 300;\n    min-width: 100%;\n    position: absolute;\n    top: 100%;\n    z-index: 2;\n  }\n\n  .react-autosuggest__suggestion {\n    cursor: pointer;\n    padding: 10px 20px;\n  }\n\n  .react-autosuggest__suggestion--highlighted {\n    background-color: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _rem = require('polished/lib/helpers/rem');

var _rem2 = _interopRequireDefault(_rem);

var _em = require('polished/lib/helpers/em');

var _em2 = _interopRequireDefault(_em);

var _reactAutosuggest = require('react-autosuggest');

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _config = require('../../config.js');

var _mixins = require('../../mixins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
# AutoSuggestInput
A basic Input that auto-suggests values.
 */
var AutosuggestContainer = _styledComponents2.default.div(_templateObject, (0, _mixins.InputReset)(), _config.colors.white, function (props) {
  return props.$invalid ? _config.colors.red : _config.colors.gray;
}, function (props) {
  return props.$invalid ? '0 0 0 1px ' + _config.colors.red : 'none';
}, (0, _rem2.default)('16px', _config.typography.baseFontSize), (0, _rem2.default)('40px', _config.typography.baseFontSize), (0, _em2.default)('15px', _config.typography.baseFontSize), _config.colors.gray, _config.colors.gray, _config.colors.white, _config.colors.gray, _config.colors.lightGray);

AutosuggestContainer.displayName = 'AutosuggestContainer';

var AutoSuggestInput = function (_React$Component) {
  _inherits(AutoSuggestInput, _React$Component);

  _createClass(AutoSuggestInput, null, [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props) {
      if (props.reduxInput && Object.prototype.hasOwnProperty.call(props.reduxInput, 'value')) {
        return {
          value: props.reduxInput.value
        };
      }

      return null;
    }
  }]);

  function AutoSuggestInput() {
    _classCallCheck(this, AutoSuggestInput);

    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    var _this = _possibleConstructorReturn(this, (AutoSuggestInput.__proto__ || Object.getPrototypeOf(AutoSuggestInput)).call(this));

    _this.state = {
      value: '',
      suggestions: []
    };

    _this.input = _react2.default.createRef();

    _this.onChange = _this.onChange.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.onSuggestionsFetchRequested = _this.onSuggestionsFetchRequested.bind(_this);
    _this.onSuggestionsClearRequested = _this.onSuggestionsClearRequested.bind(_this);
    _this.getSuggestions = _this.getSuggestions.bind(_this);
    return _this;
  }

  _createClass(AutoSuggestInput, [{
    key: 'onChange',
    value: function onChange(event, _ref) {
      var newValue = _ref.newValue;
      var reduxInput = this.props.reduxInput;


      if (reduxInput) {
        reduxInput.onChange(newValue);
      }

      this.setState({
        value: newValue
      });
    }
  }, {
    key: 'onBlur',
    value: function onBlur(event) {
      var _props = this.props,
          suggestions = _props.suggestions,
          reduxInput = _props.reduxInput;


      if (suggestions.indexOf(event.target.value) === -1) {
        if (reduxInput) {
          reduxInput.onChange('');
        }

        this.setState({
          value: ''
        });
      }
    }

    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.

  }, {
    key: 'onSuggestionsFetchRequested',
    value: function onSuggestionsFetchRequested(_ref2) {
      var value = _ref2.value;

      this.setState({
        suggestions: this.getSuggestions(value)
      });
    }

    // Autosuggest will call this function every time you need to clear suggestions.

  }, {
    key: 'onSuggestionsClearRequested',
    value: function onSuggestionsClearRequested() {
      this.setState({
        suggestions: []
      });
    }
  }, {
    key: 'getSuggestions',
    value: function getSuggestions(value) {
      var suggestions = this.props.suggestions;

      var inputValue = value.trim().toLowerCase();
      var inputLength = inputValue.length;

      return inputLength === 0 ? [] : suggestions.filter(function (suggestion) {
        return suggestion.toLowerCase().indexOf(inputValue) !== -1;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          type = _props2.type,
          label = _props2.label,
          name = _props2.name,
          invalid = _props2.invalid,
          placeholder = _props2.placeholder,
          disabled = _props2.disabled,
          onlySuggestedValuesAllowed = _props2.onlySuggestedValuesAllowed,
          onKeyPress = _props2.onKeyPress;
      var _state = this.state,
          value = _state.value,
          suggestions = _state.suggestions;

      // When a suggestion is clicked, Autosuggest needs to populate the input
      // based on the clicked suggestion. Teach Autosuggest how to calculate the
      // input value for every given suggestion.

      var getSuggestionValue = function getSuggestionValue(suggestion) {
        return suggestion;
      };
      var renderSuggestion = function renderSuggestion(suggestion) {
        return _react2.default.createElement(
          'div',
          null,
          suggestion
        );
      };

      // Autosuggest only works if there is a primitive jsx input being rendered
      // here, it requires this to properly bind refs
      var renderInputComponent = function renderInputComponent(inputProps) {
        return _react2.default.createElement('input', inputProps);
      };

      return _react2.default.createElement(
        AutosuggestContainer,
        {
          $invalid: invalid
        },
        _react2.default.createElement(
          'label',
          { htmlFor: id },
          label && _react2.default.createElement(
            'span',
            null,
            label
          ),
          _react2.default.createElement(_reactAutosuggest2.default, {
            suggestions: suggestions,
            onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
            onSuggestionsClearRequested: this.onSuggestionsClearRequested,
            getSuggestionValue: getSuggestionValue,
            renderSuggestion: renderSuggestion,
            renderInputComponent: renderInputComponent,
            inputProps: {
              id: id,
              type: type,
              name: name,
              value: value,
              placeholder: placeholder,
              disabled: disabled,
              onChange: this.onChange,
              onKeyPress: onKeyPress,
              onBlur: onlySuggestedValuesAllowed ? this.onBlur : function () {}
            }
          })
        )
      );
    }
  }]);

  return AutoSuggestInput;
}(_react2.default.Component);

AutoSuggestInput.propTypes = {
  /** The type of input */
  type: _propTypes2.default.string,
  /** The label for the input */
  label: _propTypes2.default.string,
  /** The name for the input */
  name: _propTypes2.default.string,
  /** Placeholder text for the input */
  placeholder: _propTypes2.default.string,
  /** Whether the Input is disabled */
  disabled: _propTypes2.default.bool,
  /** Whether the Input is invalid */
  invalid: _propTypes2.default.bool,
  /** Mandatory ID on the input */
  id: _propTypes2.default.string.isRequired,
  /** The suggestions to autocomplete with */
  suggestions: _propTypes2.default.arrayOf(_propTypes2.default.string),
  /** Whether the input should be contrained to only allow suggested values */
  onlySuggestedValuesAllowed: _propTypes2.default.bool,
  /** a jsx input element for use with redux-form */
  reduxInput: _propTypes2.default.shape({
    onChange: _propTypes2.default.func,
    value: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.array])
  })
};

AutoSuggestInput.defaultProps = {
  type: 'text',
  label: '',
  name: '',
  placeholder: '',
  disabled: false,
  invalid: false,
  suggestions: [],
  onlySuggestedValuesAllowed: false,
  reduxInput: null
};

AutoSuggestInput.displayName = 'AutoSuggestInput';

exports.default = AutoSuggestInput;
AutoSuggestInput.__docgenInfo = {
  'description': '',
  'methods': [{
    'name': 'getDerivedStateFromProps',
    'docblock': null,
    'modifiers': ['static'],
    'params': [{
      'name': 'props',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'onChange',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'event',
      'type': null
    }, {
      'name': '{ newValue }',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'onBlur',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'event',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'onSuggestionsFetchRequested',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': '{ value }',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'onSuggestionsClearRequested',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }, {
    'name': 'getSuggestions',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'value',
      'type': null
    }],
    'returns': null
  }],
  'displayName': 'AutoSuggestInput',
  'props': {
    'type': {
      'defaultValue': {
        'value': '\'text\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The type of input'
    },
    'label': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The label for the input'
    },
    'name': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The name for the input'
    },
    'placeholder': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Placeholder text for the input'
    },
    'disabled': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the Input is disabled'
    },
    'invalid': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the Input is invalid'
    },
    'suggestions': {
      'defaultValue': {
        'value': '[]',
        'computed': false
      },
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'string'
        }
      },
      'required': false,
      'description': 'The suggestions to autocomplete with'
    },
    'onlySuggestedValuesAllowed': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the input should be contrained to only allow suggested values'
    },
    'reduxInput': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'shape',
        'value': {
          'onChange': {
            'name': 'func',
            'required': false
          },
          'value': {
            'name': 'union',
            'value': [{
              'name': 'bool'
            }, {
              'name': 'string'
            }, {
              'name': 'number'
            }, {
              'name': 'array'
            }],
            'required': false
          }
        }
      },
      'required': false,
      'description': 'a jsx input element for use with redux-form'
    },
    'id': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'Mandatory ID on the input'
    }
  }
};